import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { element } from 'protractor';

@Component({
  selector: 'app-session-course-college-model-pop',
  templateUrl: './session-course-college-model-pop.component.html',
  styleUrls: ['./session-course-college-model-pop.component.scss']
})
export class SessionCourseCollegeModelPopComponent implements OnInit {

  SessionCoClg: FormGroup;
  courseList: any[];
  filteredCourseList: any;
  collegeList: [];
  clgcourseData: any[] = [];
  filteredclg: any[] = [];
  filteredCollegeList: any;
  courseData = [];
  list;
  radioBtn=true;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  isread = false;
  isreaddelete = false;
  isShown = false;
  collegeOneList: any;
  courseOneList: any;
  isShownCourseList = false;
  isShownCollegeList = false;
  isShownCourseDiv = false;
  isShownCollegeDiv = false;
  isCollegeRadioBtn = false;
  isCourseRadioBtn = false;
  submitcourse = false;
  submitcollege = false;
  submitbranch = false;
  RadioButtons = false;
  selectedIndex: number = 0;
  BranchList: any;
  filteredListBranch: any;
  // clgArr:any[];
  // courseArr:any[];
  map = new Map<String, String>();
  collegecourseList: any;
  checked: boolean;
  SessionFilterList: any;
  sessionList: any;
  response: any;
  deleteButton: boolean;
  SnId: any;
  allCourseListMap;
  allCollegeListMap: any;
  allBranchListMap: any;

  UserCollege
  dialogRef: MatDialogRef<any>;
  onreloaddata: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private httpClient: HttpClient, public router: Router,
    private route: ActivatedRoute, private spinner:NgxSpinnerService) { }
    
  collegeId;
  courseId;
  CollegeArr: FormArray;
  CourseArr: FormArray;
  BranchArr: FormArray;
  SessionCoClgSearchForm: FormGroup;
  userPermission:any;
  utp: any;
  sessCreate = true;
  sessUpdate = true;
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Course Intake Mapping' && element.PCreate == false)
      {
          this.sessCreate = false;  
      }
      // if(element.PageName == 'State' && element.PUpdate == false)
      // {
      
        
      //     this.sessUpdate = false;  
      // }   
      // if(element.PageName == 'State' && element.PDelete == false)
      // {
      //     this.townDelete = false;  
      // } 
    });
  }
    window.scroll(0, 0);
    let idd ='';
    this.list = true;
    this.isCollegeRadioBtn = true;
    this.isCourseRadioBtn = true;
    this.isShownCourseList = false;
    this.isShownCollegeDiv = false;
    this.fetchCollege();
    this.fetchCourse();
    this.SessionCoClg = this.fb.group({
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      BranchArr: this.fb.array([]),
      Session: new FormControl ('',[Validators.required]),
      course: new FormControl (''),
      CoStr: new FormControl (''),
      college: new FormControl (''),
      radio: new FormControl (''),
      Search: new FormControl (''),
    });
    this.SessionCoClgSearchForm = this.fb.group({
      SearchString: new FormControl (''),
    });
    let id = {}
    this.fetchSession(idd);
    this.isShownCollegeList = false;

    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } 
    // else if (this.data.key == "Delete") {
    //  this.DeletePrepopulation(this.data.selected);
    // } else {
    //   // alert(this.data.key) 
    // }
  }


  editdata(e, k){
    if (e === 'true'){
      this.radioBtn=false;
      this.list = false;
      // this.isread = false;
      // this.getFacultyData();
      this.fetchCollege();
      this.fetchCourse();
      this.clgClick();
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

   public next() {
    this.selectedIndex += 1;
  }

  public prev() {
    this.selectedIndex -= 1;
  }

  onTabChanged(event: MatTabChangeEvent) {
      if (event.tab.textLabel == 'Branch') {
      this.submitbranch = false;
      this.submitcourse = false;
      this.submitcollege = false;
      } 
      if(this.isShownCollegeList == true){ 
        let payload = {};
        payload['CoCode'] = this.SessionCoClg.value['course'];
      this.oneCourseClick(payload)
      }
      if(this.isShownCourseList == true){
        const payload = {};
        payload['CoCgCgCode'] = this.SessionCoClg.value['college'];
        this.oneClgClick(payload);
      }
      
  }

  fetchBranchIntake(courseId, collegeId) {
    const payload = {};
    let payload1 = this.SessionCoClg.value;
    this.submitcourse = false;
    this.submitbranch = true;
    this.submitcollege = false;
    if (courseId == '' && collegeId != '') {
      payload['CoCgCoCode'] = this.SessionCoClg.value['course'];
      payload['CoCgCgCode'] = collegeId;
    } else if (collegeId == '' && courseId != '') {
      payload['CoCgCoCode'] = courseId;
      payload['CoCgCgCode'] = this.SessionCoClg.value['college'];
    } else {
      payload['CoCgCoCode'] = courseId ? courseId : this.SessionCoClg.value['course'];
      payload['CoCgCgCode'] = collegeId ? collegeId : this.SessionCoClg.value['college'];
      this.onreloaddata = this.SessionCoClg.value['course'] ? this.SessionCoClg.value['course'] : this.SessionCoClg.value['college'];
    }
    payload['SessionID'] = sessionStorage.getItem('SessId');
    if (payload['CoCgCoCode'] != '' && payload['CoCgCgCode'] != '') {
      this.umsService.getSessionColgCo(payload).subscribe(res => {
        this.spinner.hide();
        this.SessionCoClg = this.fb.group({
          CourseArr: this.fb.array([]),
          BranchArr: this.fb.array([]),
          course: new FormControl(payload['CoCgCoCode']),
          college: new FormControl(payload['CoCgCgCode']),
          Session: new FormControl(payload1.Session, [Validators.required]),
        })
        if (res.status) {
          console.log("ress", res.data);
          let allBranchList = res.data;
          this.allBranchListMap = res.data;
          if (allBranchList !== undefined) {
            this.BranchArr = this.SessionCoClg.get('BranchArr') as FormArray;
          }
          allBranchList.forEach(element => {
            if (element.StrCode != null) {
              this.BranchArr.push(this.fb.group({
                StrCoCode: new FormControl(element.CoCgCoCode),
                StrCgCode: new FormControl(element.CoCgCgCode),
                StrIntake: new FormControl(element.StrIntake, [Validators.pattern('^[0-9]*$')]),
                StrName: new FormControl(element.StrName),
                StrCode: new FormControl(element.StrCode),
                SessionID: new FormControl(sessionStorage.getItem('SessId')),
                AMD: new FormControl(element.AMD)
              }));
            }
          });
        }
      })
    } else {

    }
  }


  prepopulation(e) {
    console.log("edit", e);
    this.radioBtn=false;
    sessionStorage.setItem('SessId',e.SessionID);
    this.SessionCoClg = this.fb.group({
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      BranchArr: this.fb.array([]),
      course: new FormControl (''),
      Session: new FormControl(e.SessionID,Validators.required),
      college: new FormControl (e.CgName),
      radio: new FormControl ('clg'),
    });
 
    this.oneClgClick(e);
    this.clgClick1();
  }

  clgClick1(){
    let payload = this.SessionCoClg.value;
    if(payload.Session !== '')
    {
      this.isShownCollegeDiv = true;
      this.isShownCourseDiv = false;
    }
  }

  getControls() {
     const array = this.SessionCoClg?.get('CollegeArr') as FormArray;
     return array?.controls || [];
  }
  getControls1() {
    const array = this.SessionCoClg?.get('CourseArr') as FormArray;
    return array?.controls || [];
  }
  getBranch() {
    return (this.SessionCoClg.get('BranchArr') as FormArray).controls;
  }
  clear() {
    this.SessionCoClg = this.fb.group({
      course: new FormControl (''),
      college: new FormControl (''),
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      BranchArr: this.fb.array([]),
    })
  }

  fetchCourse() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.isCourseRadioBtn = true;
    this.isCollegeRadioBtn = false;
    this.isShownCourseList = false;
    this.isShownCollegeList = true;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
        this.SessionCoClg.controls["course"].setValue('');
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });

  }

  removeCourseArr(i) {
    this.CourseArr.removeAt(i);
  }
  removeCollegeArr(i) {
    this.CourseArr.removeAt(i);
  }

  fetchCollege() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.umsService.getCollege(payload).subscribe(res => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        this.SessionCoClg.controls["college"].setValue('');
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });

  }

  fetchCollege2(CoCgCgCode) {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.umsService.getCollege(payload).subscribe(res => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });

  }

  clgClick() {
    let payload = this.SessionCoClg.value;
    if(payload.Session !== '')
    {
      this.isShownCollegeDiv = true;
      this.isShownCourseDiv = false;
    }
      this.isCollegeRadioBtn = true;
      this.isCourseRadioBtn = false;
      this.isShownCourseList = false;
      this.isShownCollegeList = false;
      this.submitcourse = false;
      this.submitbranch = false;
      this.submitcollege = false;
  }

  courseClick() {
    let payload = this.SessionCoClg.value;
    if(payload.Session !== '')
    {
      this.isShownCollegeDiv = false;
      this.isShownCourseDiv = true;
    }
    this.isCollegeRadioBtn = false;
    this.isCourseRadioBtn = true;
    this.submitcourse = false;
    this.submitbranch = false;
    this.submitcollege = false;
    this.isShownCourseList = false;
    this.isShownCollegeList = false;
  }
  addclgcourse() {
    let payload = this.SessionCoClg.value;
    payload['CourseArr'].forEach(element => {
      if (element.clgcoursecheckbox == true) {
        let xxxx = {};
        xxxx['CoCgCgCode'] = element.CoCgCgCode;
        xxxx['CoCgCoCode'] = element.CoCode;
        this.umsService.addCourseCollege(xxxx).subscribe(res => {
          if (res.status) {
            this.umsService.openSnackbar(res.message);
            //this.prepopulation();
          } else {
            //this.umsService.openSnackbar(res.message);
          }
        });
        this.ngOnInit()
      }
    });
     this.SessionCoClg.reset();
  }

  getSnId(e){
    this.radioBtn=false;
    this.RadioButtons=true;
    this.isShownCollegeDiv = false;
    this.isShownCourseDiv = false;
    this.isShownCollegeList = false;
    this.isShownCourseList = false;
    this.SnId = e;
    sessionStorage.setItem('SessId', e);
    this.SessionCoClg = this.fb.group({
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      BranchArr: this.fb.array([]),
      course: new FormControl (''),
      Session: new FormControl (e,[Validators.required]),
      college: new FormControl (''),
      radio: new FormControl (''),
    });
    // this.SessionCoClg.reset();
  }

  oneClgClick(id) {
    console.log("id", id);
    this.onreloaddata = id;
    this.submitcourse = true;
    this.submitbranch = false;
    this.submitcollege = false;
    this.spinner.show();
    let payload1 =this.SessionCoClg.value;
    const payload = {}; 
    payload['CoCgCgCode'] =id.CgCode ? id.CgCode : id.CoCgCgCode;
    payload['SessionID'] = sessionStorage.getItem('SessId');
    this.isShownCourseList = true
      this.umsService.getSessionColgCo(payload).subscribe(res => {
       this.spinner.hide();
        if (res.status) {
          let allcourseList = res.data;
          this.allCourseListMap = res.data;
          this.SessionCoClg = this.fb.group({
            CollegeArr: this.fb.array([]),
            CourseArr: this.fb.array([]),
            BranchArr: this.fb.array([]),
            course: new FormControl (''),
            // college: new FormControl (''),
            Session: new FormControl(payload1.Session,[Validators.required]),
            college: new FormControl(payload['CoCgCgCode']),
          })
          
          if (allcourseList !== undefined) {
            this.CourseArr = this.SessionCoClg.get('CourseArr') as FormArray;
          }
          allcourseList.forEach(element => {
              this.CourseArr.push(this.fb.group({
                CoCgCoCode: new FormControl(element.CoCgCoCode),
                CoCgCgCode: new FormControl(element.CoCgCgCode),
                RecongnizedIntake: new FormControl(element.RecongnizedIntake,[Validators.pattern('^[0-9]*$')]),
                PermittedIntake: new FormControl(element.PermittedIntake,[Validators.pattern('^[0-9]*$')]),
                CgName: new FormControl(element.CgName),
                CoName: new FormControl(element.CoName),
                SessionID: new FormControl(sessionStorage.getItem('SessId')),
                AMD:new FormControl(element.AMD)
              }));
          });

        }
        })
  }
  

  freshCourseCollageMapping(allrecord, cgcode) {
    let data = allrecord.data
    this.SessionCoClg = this.fb.group({
      CollegeArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      BranchArr: this.fb.array([]),
      course: new FormControl (''),
      college: new FormControl (''),
    })
    this.collegeList = data.CourseArr;
    if (data !== undefined) {
      data.map((element, i) => {
        this.CourseArr = this.SessionCoClg.get('CourseArr') as FormArray;
        this.CourseArr.push(this.fb.group({
          clgcoursecheckbox: new FormControl(false),
          CoCgCoCode: new FormControl(element.CoName),
          CoCode: new FormControl(element.CoCode),
          CoCgCgCode: new FormControl(cgcode),
          CoCgCgName: new FormControl(element.CgName),
          RecongnizedIntake: new FormControl (''),
          PermittedIntake: new FormControl (''),
          toggle: false
        }));
      });
    }
  }

  addclgcourse1() {
    let payload = this.SessionCoClg.value;
    payload['CollegeArr'].forEach(element => {
      if (element.clgcoursecheckbox == true) {
        let xxxx = {};

        xxxx['CoCgCgCode'] = element.CgCode;
        xxxx['CoCgCoCode'] = element.CoCgCoCode;
        this.umsService.addCourseCollege(xxxx).subscribe(res => {
          if (res.status) {
            this.umsService.openSnackbar(res.message);
            //this.prepopulation();
          } else {
            //this.umsService.openSnackbar(res.message);
          }
        });
        this.ngOnInit()
      }
    });
    this.SessionCoClg.reset();
  }

  freshCourseClick(e) {
    this.isShownCourseList = false;
    this.isShownCollegeList = true;
    let payload = {}
    this.collegeId = e;
    this.umsService.getCollege(payload).subscribe(res => {
      let data = res.data
      this.SessionCoClg = this.fb.group({
        course: new FormControl (''),
        college: new FormControl (''),
        CollegeArr: this.fb.array([]),
        CourseArr: this.fb.array([]),
        BranchArr: this.fb.array([]),
      })
      this.courseList = data.CollegeArr;
      if (data !== undefined) {
        data.map((element, i) => {
          this.CollegeArr = this.SessionCoClg.get('CollegeArr') as FormArray;
          this.CollegeArr.push(this.fb.group({
            clgcoursecheckbox: new FormControl(false),
            CoCgCgCode: new FormControl(element.CgName),
            CgCode: new FormControl(element.CgCode),
            CoCgCoCode: new FormControl(e),
            CoCgCoName: new FormControl(element.CoName),
            RecongnizedIntake: new FormControl (''),
            PermittedIntake: new FormControl (''),
            toggle: false
          }));

        });

      }

    });


  }

  fetchSelectedCourseCollege(id) {
    this.collegeId = id
    const payload = {};
    payload['CgCode'] = id;
    payload['CoCode'] = ''
    this.umsService.getCollegeCourse(payload).subscribe(res => {
      if (res.status) {
        this.collegecourseList = res.data;
      }
    });
  }


  oneCourseClick(id) {
    this.onreloaddata = id;
    this.submitcourse = false;
    this.submitbranch = false;
    this.submitcollege = true;
    this.spinner.show();
    let payload1 = this.SessionCoClg.value;
    const payload = {};
    payload['CoCgCoCode'] =id.CoCode;
    payload['SessionID'] = sessionStorage.getItem('SessId');
    this.isShownCollegeList = true;
      this.umsService.getSessionColgCo(payload).subscribe(res => {
       this.spinner.hide();
        if (res.status) {
          let allcollegeList = res.data;
          this.allCollegeListMap = res.data;
          this.SessionCoClg = this.fb.group({
            CollegeArr: this.fb.array([]),
            CourseArr: this.fb.array([]),
            BranchArr: this.fb.array([]),
            course: new FormControl(id.CoCode),
            branch : new FormControl(''),
            college: new FormControl (''),
            Session: new FormControl (payload1.Session,[Validators.required]),
            
          })
          if (allcollegeList !== undefined) {
            this.CollegeArr = this.SessionCoClg.get('CollegeArr') as FormArray;
          }
          allcollegeList.forEach(element => {
              this.CollegeArr.push(this.fb.group({
                CoCgCoCode: new FormControl(element.CoCgCoCode),
                CoCgCgCode: new FormControl(element.CoCgCgCode),
                CgName: new FormControl(element.CgName),
                CoName: new FormControl(element.CoName),
                RecongnizedIntake: new FormControl(element.RecongnizedIntake,[Validators.pattern('^[0-9]*$')]),
                PermittedIntake: new FormControl(element.PermittedIntake,[Validators.pattern('^[0-9]*$')]),
                SessionID: new FormControl(sessionStorage.getItem('SessId')),
                AMD:new FormControl(element.AMD)
              }));
          });

        }
        })
  }
  slideToggleChange(event: MatSlideToggleChange, e,type) {
    if (event.source.checked == false && type == "course") {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }), body: {
          CoCgCoCode: e.CoCode,
          CoCgCgCode: e.CoCgCgCode
        },
      };
   
      this.httpClient.delete(environment.serviceUrl + '/masters/college-course', options)
      .subscribe((s) => {
        
      }, (ERROR: HttpErrorResponse) => {
        
     });
    }else if(event.source.checked == false && type == "college"){
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }), body: {
          CoCgCoCode: e.CoCgCoCode,
          CoCgCgCode: e.CgCode
        },
      };
   
      this.httpClient.delete(environment.serviceUrl + '/masters/college-course', options)
      .subscribe((s) => {
        
      }, (ERROR: HttpErrorResponse) => {
        
     });
    }

  }

  back() {
    this.SessionCoClg.reset();
    let idd ='';
    this.list = true;
    this.isCollegeRadioBtn = true;
    this.isCourseRadioBtn = true;
    this.isShownCourseList = false;
    this.isShownCollegeList = false;
    this.isShownCollegeDiv=false;
    this.isShownCourseDiv=false;
    let id = {}
    this.fetchSession(idd);
  }

  fetchSession(id) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }
 submitFun()
 {
  if(this.SessionCoClg.invalid)
  {
    this.SessionCoClg.get('Session').markAsTouched();
  }
  else
  {
    this.submit();
  }
 }
 submitFun1() {
  if(this.SessionCoClg.invalid)
  {
    this.SessionCoClg.get('Session').markAsTouched();
  }
  else
  {
    this.submit1();
  }
 }
  
submitBranch()
 {
  if(this.SessionCoClg.invalid)
  {
    this.SessionCoClg.get('Session').markAsTouched();
  }
  else
  {
    this.SaveBranchIntake();
  }
 }


// SaveBranchIntake() {
//     this.spinner.show();
//     let branchData = this.SessionCoClg.get('BranchArr') as FormArray;
//     let payload = branchData.value;
//     payload.forEach(element => {
//       if (element.AMD == null || element.AMD == "") {
//         this.allBranchListMap.forEach(branchAMD => {
//           if (branchAMD.StrCode == element.StrCode) {
//             if (branchAMD.StrIntake == element.StrIntake) {
//               element.AMD = "";
//             } 
//             else {
//               element.AMD = "M";
//             }
//           } else {
            
//           }
//         });
//       }
//     });
//     let noerror = true;
//     let totalBranchIntake = 0;
//     let collegeCode = '';
//     payload.forEach(element => {
//       element.StrIntake = parseInt(element.StrIntake);
//       element.SessionID = parseInt(element.SessionID);
//       collegeCode = element.StrCgCode;
//       totalBranchIntake += element.StrIntake;
//       this.umsService.addSessionExamStrColgCo(element).subscribe(res => {
//         this.spinner.hide();
//         if (res.status){
//           this.response = res.message
//         }
//       },(ERROR: HttpErrorResponse) => {
//         noerror = false;
//       });
//     });

//   const payload1: any = {
//   CoCgCgCode: collegeCode,
//   SessionID: sessionStorage.getItem('SessId')
//   };
// console.log('payload1', payload1);
// this.umsService.getSessionColgCo(payload1).subscribe(res => {
//   if (res.status && Array.isArray(res.data)) {
//     const allCourseList = res.data;
//     this.allCourseListMap = allCourseList;

//     const selectedCourse = allCourseList.find(
//       (element: any) => element.CoCgCoCode === this.SessionCoClg.value['course']
//     );
//     console.log('selectedCourse', selectedCourse);
//     if (selectedCourse) {
//       const { PermittedIntake, RecongnizedIntake } = selectedCourse;

//       // Check if both intakes are null or 0
//       if (
//         (!PermittedIntake && !RecongnizedIntake) ||
//         PermittedIntake === 0 ||
//         RecongnizedIntake === 0 
//       ) {
//         const courseIntake: any = {
//           CoCgCoCode: this.SessionCoClg.value['course'],
//           CoCgCgCode: this.SessionCoClg.value['college'],
//           SessionID: sessionStorage.getItem('SessId'),
//           PermittedIntake: totalBranchIntake,
//           RecongnizedIntake: totalBranchIntake,
//           AMD: 'A'
//         };

//         console.log('courseIntake', courseIntake);

//         this.umsService.addSessionColgCo(courseIntake).subscribe(
//           res => {
//             this.spinner.hide();
//             if (res.status) {
//               this.response = res.message;
//             }
//           },
//           (error: HttpErrorResponse) => {
//             noerror = false;
//           }
//         );
//       } else {
//         if(PermittedIntake != totalBranchIntake) {
//            console.log(
//           `Existing course has intake ${PermittedIntake ?? 0}, but the total branch intake is ${totalBranchIntake}. Please update the course intake accordingly.`
//         );
//       }
//       }
//     }
//   }
// });

//     if(noerror){
//       this.data = {}
//       this.data['message'] = 'Submitted Successfully'
//       this.data['title'] = 'Information'
//       this.data['icon'] = 'fas fa-check'
//       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
//       this.dialogRef.afterClosed().subscribe((result) => {
//         this.fetchBranchIntake('','');
//       });
//     }else{
//       this.data = {}
//       this.data['message'] = 'Please Reffer there was an error submiting'
//       this.data['title'] = 'Information'
//       this.data['icon'] = 'fas fa-check'
//       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
//       this.dialogRef.afterClosed().subscribe((result) => {
//         this.oneClgClick(this.onreloaddata);
//       });
//     } 
//   }

SaveBranchIntake() {
  this.spinner.show();
  let branchData = this.SessionCoClg.get('BranchArr') as FormArray;
  let payload = branchData.value;
  let totalBranchIntake = 0;
  let collegeCode = '';
  let noerror = true;

  // Calculate total intake and manage AMD
  payload.forEach(element => {
    collegeCode = element.StrCgCode;
    totalBranchIntake += parseInt(element.StrIntake) || 0;
    if (!element.AMD) {
      const branchAMD = this.allBranchListMap.find(b => b.StrCode == element.StrCode);
      element.AMD = branchAMD && branchAMD.StrIntake != element.StrIntake ? 'M' : '';
    }
  });

  const payload1 = {
    CoCgCgCode: collegeCode,
    SessionID: sessionStorage.getItem('SessId')
  };

  this.umsService.getSessionColgCo(payload1).subscribe(res => {
    if (res.status && Array.isArray(res.data)) {
      const selectedCourse = res.data.find(
        (e: any) => e.CoCgCoCode === this.SessionCoClg.value['course']
      );

      if (selectedCourse) {
        const { PermittedIntake, RecongnizedIntake } = selectedCourse;

        // If no course intake, insert it using branch sum
        if (!PermittedIntake || !RecongnizedIntake) {
          const courseIntake = {
            CoCgCoCode: this.SessionCoClg.value['course'],
            CoCgCgCode: this.SessionCoClg.value['college'],
            SessionID: sessionStorage.getItem('SessId'),
            PermittedIntake: totalBranchIntake,
            RecongnizedIntake: totalBranchIntake,
            AMD: 'A'
          };
          this.umsService.addSessionColgCo(courseIntake).subscribe(() => {
            this.saveBranches(payload);
          });
        } else {
          if (PermittedIntake != totalBranchIntake) {
            this.spinner.hide();
            this.data = {
              message: `Existing course has intake ${PermittedIntake}, but total branch intake is ${totalBranchIntake}. Please update the course intake accordingly.`,
              title: 'Error',
              icon: 'fas fa-exclamation-triangle'
            };
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data).afterClosed().subscribe(() => {
              this.fetchBranchIntake(this.SessionCoClg.value['course'], collegeCode);
            });
            return; // stop here
          } else {
            this.saveBranches(payload); // save normally
          }
        }
      }
    }
  });
}

saveBranches(payload: any[]) {
  let noerror = true;

  payload.forEach(element => {
    element.StrIntake = parseInt(element.StrIntake);
    element.SessionID = parseInt(element.SessionID);
    this.umsService.addSessionExamStrColgCo(element).subscribe(
      res => {
        if (res.status) this.response = res.message;
      },
      () => noerror = false
    );
  });

  this.spinner.hide();
  this.data = {
    message: noerror ? 'Submitted Successfully' : 'Please refer, there was an error submitting.',
    title: 'Information',
    icon: 'fas fa-check'
  };
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
  this.dialogRef.afterClosed().subscribe(() => {
    if (noerror) this.fetchBranchIntake('', '');
    else this.oneClgClick(this.onreloaddata);
  });
}

  submit() {
    this.spinner.show();
    let abcd = this.SessionCoClg.get('CourseArr') as FormArray;
    let payload = abcd.value;
    payload.forEach(element => {
      if (element.AMD == null || element.AMD == "") {
        this.allCourseListMap.forEach(CourseAMD => {
          if (CourseAMD.CoCgCoCode == element.CoCgCoCode) {
            if (CourseAMD.PermittedIntake == element.PermittedIntake && CourseAMD.RecongnizedIntake == element.RecongnizedIntake) {
              element.AMD = "";
            } 
            else {
              element.AMD = "M";
            }
          } else {
            
          }
        });
      }
    });
    let noerror = true;
    payload.forEach(element => {
      element.PermittedIntake = parseInt(element.PermittedIntake);
      element.RecongnizedIntake = parseInt(element.RecongnizedIntake);
      element.SessionID = parseInt(element.SessionID);
      this.umsService.addSessionColgCo(element).subscribe(res => {
        this.spinner.hide();
        if (res.status){
          this.response = res.message
        }
      },(ERROR: HttpErrorResponse) => {
        noerror = false;
      });
    });
    if(noerror){
      this.data = {}
      this.data['message'] = 'Submitted Successfully'
      this.data['title'] = 'Information'
      this.data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.oneClgClick(this.onreloaddata);
      });
    }else{
      this.data = {}
      this.data['message'] = 'Please Reffer there was an error submiting'
      this.data['title'] = 'Information'
      this.data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.oneClgClick(this.onreloaddata);
      });
    } 
  }

  submit1() {
    this.spinner.show();
    let ABCD = this.SessionCoClg.get('CollegeArr') as FormArray;
    let payload = ABCD.value;
    payload.forEach(element => {
      if (element.AMD == null || element.AMD == "") {
        this.allCollegeListMap.forEach(CollegeAMD => {
          if (CollegeAMD.CoCgCoCode == element.CoCgCoCode) {
            if (CollegeAMD.PermittedIntake == element.PermittedIntake && CollegeAMD.RecongnizedIntake == element.RecongnizedIntake) {
              element.AMD = "";
            } 
            else {
              element.AMD = "M";
            }
          } else {
            
          }
        });
      }
    });
    let noerror = true;
    payload.forEach(element => {
      element.PermittedIntake = parseInt(element.PermittedIntake);
      element.RecongnizedIntake = parseInt(element.RecongnizedIntake);
      element.SessionID = parseInt(element.SessionID);
      this.umsService.addSessionColgCo(element).subscribe(res => {
        this.spinner.hide();
        if (res.status){
          this.response = res.message
        } 
       },(ERROR: HttpErrorResponse) => {
          noerror = false;
      });
    });
    if(noerror){
      this.data = {}
      this.data['message'] = 'Submitted Successfully'
      this.data['title'] = 'Information'
      this.data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.oneClgClick(this.onreloaddata);
        this.isShownCourseList=false;
      });
    }else{
      this.data = {}
      this.data['message'] = 'Please Reffer there was an error submiting'
      this.data['title'] = 'Information'
      this.data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, this.data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.oneClgClick(this.onreloaddata);
      });
    }
  }

  errorcheckP(i){
     return i.controls['PermittedIntake'].touched && i.controls['PermittedIntake'].errors?.pattern
     
   }
   errorcheckBr(i){
    return i.controls['StrIntake'].touched && i.controls['StrIntake'].errors?.pattern
   }

   errorcheckR(i){
     return i.controls['RecongnizedIntake'].touched && i.controls['RecongnizedIntake'].errors?.pattern
   
  }

intake(val: any, i: number, value: string) {
  const tempData = val.target.value;

  // Get the FormArray safely
  let array = this.SessionCoClg.get(value) as FormArray;
  if (!array) return;

  // Get the FormGroup safely
  let group = array.at(i) as FormGroup;
  if (!group) return;

  // Access controls safely
  let recControl = group.get('RecongnizedIntake');
  let strControl = group.get('StrIntake');
  let permControl = group.get('PermittedIntake');

  const payload = array.value;

  // Check intake vs permitted intake
  if (permControl && recControl && parseInt(payload[i].RecongnizedIntake) < parseInt(tempData)) {
    permControl.setErrors({ intakeError: true });
  }

  // Handle RecongnizedIntake validators
  if (recControl) {
    if (payload[i].RecongnizedIntake === '') {
      recControl.setValidators([Validators.required]);
      recControl.updateValueAndValidity();
      recControl.markAsTouched();
    } else {
      recControl.clearValidators();
      recControl.updateValueAndValidity();
    }
  }

  // Handle StrIntake validators
  if (strControl) {
    if (payload[i].StrIntake === '') {
      strControl.setValidators([Validators.required]);
      strControl.updateValueAndValidity();
      strControl.markAsTouched();
    } else {
      strControl.clearValidators();
      strControl.updateValueAndValidity();
    }
  }
}
}

